import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Priority } from "../../../model/priority";
import { PrioritiesService } from "../../../services/priorities.service";
import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { Navigation } from "../../../model/navigation";
import { Messages } from "../../../model/messages";
import { SingleChoice } from "../../../model/singlechoice";
@Component({
  selector: "priority",
  templateUrl: "./priority.component.html",
  styleUrls: ["./priority.component.css"],
})
export class PriorityListComponent implements OnInit {
  priorityCount: number = 0;
  priorities: BehaviorSubject<Priority[]> = new BehaviorSubject<Priority[]>([]);
  filteredPriority: BehaviorSubject<Priority[]> = new BehaviorSubject<
    Priority[]
  >([]);
  searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>("");
  selectedPriority: Priority | null = null;
  messages: BehaviorSubject<Messages>;
  title: BehaviorSubject<string> = new BehaviorSubject<string>("");
  @Output() prioritySelected = new EventEmitter<number>();
  @Output() createNewPriority = new EventEmitter<void>();
  @Input() choiceEvent: SingleChoice = SingleChoice.EMPTY;
  @Input() isMobile: boolean = false;
  constructor(
    private priorityService: PrioritiesService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.title.next("priorities.title");
    const token = this.authService.token;

    this.priorityService.priorities(token).subscribe({
      next: (messages) => {
        if (messages.hasAnyMessages) {
          this.messages.next(messages);
        }
      },
      complete: () => {},
    });

    this.priorityService.prioritiesObservable.subscribe((data) => {
      const sortedPrioties = data.sort((a, b) =>
        a.value.localeCompare(b.value)
      );
      this.priorities.next(sortedPrioties);
      this.filteredPriority.next(sortedPrioties);
      this.priorityCount = sortedPrioties.length;
    });
  }
  searchPriority(): void {
    const query = this.searchTerm.getValue().toLowerCase();
    const filtered = query
      ? this.priorities.value.filter((priority) =>
          priority.value.toLowerCase().includes(query)
        )
      : this.priorities.value;

    this.filteredPriority.next(filtered);
  }

  select(priority: Priority) {
    if (this.choiceEvent && this.choiceEvent.topic == "priority") {
      if (priority && priority.id) {
        this.priorityService
          .makeBackgroundColor(priority.id)
          .subscribe((color) => {
            const background = color;
            this.priorityService.makeColor(priority.id!!).subscribe((c) => {
              const color = c;
              this.priorityService
                .makeImportance(priority.id!!)
                .subscribe((i) => {
                  const importance = i;
                  this.choiceEvent.choose(
                    priority.id!!,
                    priority.value,
                    background,
                    color,
                    importance
                  );
                });
            });
          });
      }
    } else {
      this.priorityService.select(priority);

      if (priority && priority.id) {
        this.router.navigate([`priority/${priority.id}`]).then(() => {
          this.prioritySelected.emit(priority.id!!);
        });
      }
    }
  }

  createPriority(): void {
    this.createNewPriority.emit();

    const newPriority = new Priority(Navigation.NEW, "", "", 2);
    this.priorityService.select(newPriority);
    this.router.navigate([`priority/` + Navigation.NEW]).then(() => {
      this.prioritySelected.emit(Navigation.NEW);
    });
  }
  clearFilter(): void {
    this.searchTerm.next("");
    this.filteredPriority.next(this.priorities.value);
  }
}
